import request from '@/util/request'


export const navList = (data) => request.post('/api/getCate', data);  //导航接口

export const bannerList = (data) => request.post('/api/adList', data);  //轮播图接口

export const submitMsg = (data) => request.post('/api/message', data);  //提交留言

export const getProductSelect = (data) => request.post('/api/productSel', data);  //获取产品模块筛选项

export const getProductList = (data) => request.post('/api/productList', data);  //获取产品列表

export const getProductDetail = (data) => request.post('/api/productDetail', data);  //获取产品详情

export const getProductGetlist = (data) => request.post('/api/productGetlist', data);  //获取购物车列表

export const orderSubmit = (data) => request.post('/api/orderSubmit', data);  //未登录提交订单

export const userorderSubmit = (data) => request.post('/api/userorderSubmit', data);  //登录提交订单

export const userCart = (data) => request.post('/api/userCart', data);  //保存购物车

export const sendCode = (data) => request.post('/api/sendCode', data);  //获取验证码

export const checkLogin = (data) => request.post('/api/checkLogin', data);  //验证码登录

export const editInfo = (data) => request.post('/api/editInfo', data);  //修改信息

export const userInfo = (data) => request.post('/api/userInfo', data);  //查询用户信息

export const sendEmailCode = (data) => request.post('/api/sendEmailCode', data);  //获取验证码（修改邮箱）

export const editEmail = (data) => request.post('/api/editEmail', data);  //修改邮箱

export const userorderList = (data) => request.post('/api/userorderList', data);  //历史订单

export const articleList = (data) => request.post('/api/articleList', data);  //新闻列表

export const eventsList = (data) => request.post('/api/eventsList', data);  //展会列表

export const articleDetail = (data) => request.post('/api/articleDetail', data);  //新闻详情

export const eventsDetail = (data) => request.post('/api/eventsDetail', data);  //展会详情

export const productGetDiseasesslist = (data) => request.post('/api/productGetDiseasesslist', data);  //获取疾病列表

export const productGetDiseaseslist = (data) => request.post('/api/productGetDiseaseslist', data);  //获取产品筛选二级列表

export const getAbout = (data) => request.post('/api/getAbout', data);  //获取产品二级列表